import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { map, catchError } from 'rxjs/operators';
import { Router, ActivatedRoute } from '@angular/router';
import {
  StepIndicatorModel, StepIndicatorService, ConfirmModalPopupModel,
  GridOptionsModel, AccordionModel,
  ColumnDefinitionsModel, PaginationsModel
} from 'lib/ng2-sapmp/src/ui-components';
import { UtilityService, AdobeAnalyticsService } from 'lib/ng2-sapmp/src/providers';
import { EnrollmentDateModel, SignUpOutputModel, SignUpInputModel, FanModel, EnrollmentCheckboxModel } from './../shared/models/signup.models';
import { SignupService } from './../shared/providers/signup.service';
import { AccordionComponent } from 'lib/ng2-sapmp/src/ui-components/accordion/accordion.component';
import { element } from 'protractor';

declare var ENV_VAR: any; // global variable set in env.js file, imported in index.html

@Component({
  selector: 'app-startdate',
  templateUrl: './startdate.component.html',
  styleUrls: ['./startdate.component.scss'],
  encapsulation: ViewEncapsulation.None,
  providers: [SignupService, AdobeAnalyticsService]
})

export class StartdateComponent implements OnInit {

  public dateError: boolean;
  public errorMessage: string;
  public showSupportModal: boolean;
  public learnMoreModal: ConfirmModalPopupModel;
  public enrollDatePopup: ConfirmModalPopupModel;
  public pageDescription: Array<any>;
  public formInputs: Array<any>;
  public gridOption: GridOptionsModel;
  private enrollDates: EnrollmentDateModel;
  private signupOutputModel: SignUpOutputModel;
  private signupInputModel: SignUpInputModel;
  private activeFANList: Array<FanModel> = [];
  private futureEnrollList: Array<FanModel> = [];
  private initialSignup = false;
  public authenticatepage: boolean;
  public pageContent: any;
  public eventEmit: any;
  article: any;
  title: any;
  supportArticles: any;
  confirmModalPopup: ConfirmModalPopupModel;
  initModal: boolean;
  public mixedCombination: boolean;
  public emmProductCode: any;
  public oemStatus: boolean;
  manageProduct: any;
  showEnrollDetailsModal = false;
  supportArticle = false;
  enrollmentCheckbox: EnrollmentCheckboxModel;
  existingDateExistCount: number;
  existingDateAbsentCount: number;

  constructor(private route: ActivatedRoute, private router: Router,
    private activatedRoute: ActivatedRoute,
    private stepindicatorService: StepIndicatorService,
    private utilityService: UtilityService,
    private signupService: SignupService,
    private adobeAnalyticsService: AdobeAnalyticsService) {
    const signupModel = this.signupService.getSignupModel();
    this.initModal = false;
    let revisedFanList;
    this.mixedCombination = false;
    let minDate = new Date()
    if (signupModel) {
      this.signupOutputModel = signupModel.outputModel;
      this.signupInputModel = signupModel.inputModel;
      this.initialSignup = signupModel.initialSignup;
      revisedFanList = this.signupOutputModel.FANList.revisedFanList;
      this.authenticatepage = true;
    } else {
      this.authenticatepage = false;
      this.router.navigate(['signup']);
    }
    this.enrollmentCheckbox = new EnrollmentCheckboxModel();
    this.existingDateExistCount = 0; 
    this.existingDateAbsentCount = 0;
    // on return
    if (this.signupOutputModel && this.signupOutputModel.deviceEnrollDate) {
      this.enrollDates = this.signupOutputModel.deviceEnrollDate;
      if( this.signupOutputModel.deviceEnrollDate.existing ){
        this.enrollmentCheckbox.checked = true;
      }else if( this.signupOutputModel.deviceEnrollDate.existing !== undefined ||  this.signupOutputModel.deviceEnrollDate.existing === null ){
        this.enrollmentCheckbox.checked = false;
      }
    }


    // check this also for revised case
    if (revisedFanList) {
      revisedFanList.forEach(fan => {
        if (fan.existDeviceEffectiveDate && new Date(fan.existDeviceEffectiveDate) > minDate ) {
          this.enrollDates.existing = new Date(minDate.getFullYear(), minDate.getMonth(), (minDate.getDate() + 1));
        }
        if (fan.accountSubStatus === 'Active') {
          this.activeFANList.push(fan);
          fan.existDeviceEffectiveDate ? this.existingDateExistCount++ : this.existingDateAbsentCount++;
        } else {
          this.futureEnrollList.push(fan);
        }
      });
    }
  }

  ngOnInit() {
    //document.title = this.utilityService.getPageTitleConfig()[this.router.routerState.snapshot.url];

    //if (!this.authenticatepage) {
    //  return;
    //}
    this.stepindicatorService.setCurrentStep(this.activatedRoute.snapshot.url[0].path);
    this.stepindicatorService.setVisibility(true);
    // this.emmProductCode = sessionStorage.getItem('emmProductCode');
    this.manageProduct = JSON.parse(sessionStorage.getItem('manage-product'));
    this.emmProductCode = this.manageProduct.emmProductCode;
    if (this.emmProductCode === 'DMPSKME' || this.emmProductCode === 'DMPGZTP') {
      this.oemStatus = true;
    } else {
      this.oemStatus = false;
    }
    //this.signupService.pageContent(this.utilityService.getEnvConfig().contentUrl.signup.startdate).
    //  subscribe(respobj => {
        this.pageContent = this.route.snapshot.data.pageData.signupstartdate;
        this.learnMoreModal = new ConfirmModalPopupModel();
        this.learnMoreModal.modalHeader = '';
        this.learnMoreModal.modalSubHeader = '';
        // tslint:disable-next-line:max-line-length
        this.learnMoreModal.modalMessage = this.pageContent.learnMoreModal.description;
        this.learnMoreModal.showCancelButton = false;
        this.enrollDatePopup = new ConfirmModalPopupModel();
        this.enrollDatePopup.modalHeader = this.pageContent.enrollDatePopup.heading;
        if(!this.oemStatus) {
          this.enrollDatePopup.modalMessage =this.pageContent.enrollDatePopup.description;
        }
        else {
          this.enrollDatePopup.modalMessage = this.pageContent.enrollDatePopup.descriptionOem;
        }
        // tslint:disable-next-line:max-line-length
        this.enrollDatePopup.showCancelButton = false;
        if (this.activeFANList.length > 0 && this.futureEnrollList.length > 0) {
          this.mixedCombination = true;
        }
        this.pageDescription = [{
          'header': this.pageContent.currentDeployAccount.heading,
          // tslint:disable-next-line:max-line-length
          'description': this.pageContent.currentDeployAccount.description,
          'accordion': [this.createAccordionModel('ActiveFAN',
            this.pageContent.currentDeployAccount.ariaLabel)],
          'hide': !this.activeFANList.length,
          'moreThanFiveFan': this.activeFANList.length > 5,
          // tslint:disable-next-line:max-line-length
          'gridHeader': (this.activeFANList.length === 1) ? this.activeFANList.length + '&ensp; ' + this.pageContent.currentDeployAccount.gridHeaderSingular: this.activeFANList.length + '&ensp; ' + this.pageContent.currentDeployAccount.gridHeaderPlural,
          'gridOptions': this.createGridOptions('active'),
          'gridCallback': this.updateActiveList,
          'class': 'already-enrolled-devices',
          'subHead': 'Devices are already enrolled for these accounts.'
        }
        , {
          'header': this.pageContent.futureDeployAccount.heading,
          'description': this.pageContent.futureDeployAccount.description,
          'accordion': [this.createAccordionModel('FutureFAN',
            this.pageContent.futureDeployAccount.ariaLabel)],
          'hide': !this.futureEnrollList.length,
          'moreThanFiveFan': this.futureEnrollList.length > 5,
          // tslint:disable-next-line:max-line-length
          'gridHeader': (this.futureEnrollList.length === 1) ? this.futureEnrollList.length + '&ensp; ' + this.pageContent.futureDeployAccount.gridHeaderSingular: this.futureEnrollList.length + '&ensp; ' + this.pageContent.futureDeployAccount.gridHeaderPlural,
          'gridOptions': this.createGridOptions('future'),
          'gridCallback': this.updateFutureList,
          'class': 'change-device-enrollment-dates',
          'subHead': 'To change device enrollment dates, select a new date.'
        }, {
          'header': this.pageContent.heading,
          'header1': this.pageContent.header1,
          'description': this.pageContent.description,
          'descriptionOem': this.pageContent.descriptionOem,
          'hide': this.activeFANList.length || this.futureEnrollList.length
        }
        ];
        if (this.activeFANList.length === 0 && this.futureEnrollList.length > 0) { // all future.
          this.formInputs = [{
            id: 'new',
            title: this.pageContent.newDevice.heading,
            dateInput: this.createDatePickerInput('new'),
            toolTipText: this.pageContent.newDevice.toolTipText,
            label: 'Enrollment date (devices pending enrollment)'
          }, {
            id: 'existing',
            title: this.pageContent.existingDevice.heading,
            dateInput: this.createDatePickerInput('existing'),
            toolTipText: this.pageContent.existingDevice.toolTipText,
            // label: 'Enrollment date (enrolled devices)'
            label: 'Enrollment date (all existing devices)'
          }];
        } else if (this.futureEnrollList.length === 0 && this.activeFANList.length > 0) { // it will have two cases, check if the existing date is present or not.
          // document.getElementsByClassName('enter-date').style.cssText = disabled;
          this.formInputs = [{
            id: 'newActive',
            title: this.pageContent.newDevice.heading,
            dateInput: this.createDatePickerInput('new', 'newActive'),
            toolTipText: this.pageContent.newDevice.toolTipText,
            label: 'Enrollment date (enrolled devices)'
          }];
          if( ( this.existingDateExistCount > 0 && this.existingDateAbsentCount > 0) || this.existingDateAbsentCount > 0 ){ // mix past scenario
            this.formInputs.push({
              id: 'existing',
              title: this.pageContent.existingDevice.heading,
              dateInput: this.createDatePickerInput('existing'),
              toolTipText: this.pageContent.existingDevice.toolTipText,
              label: 'Enrollment date (all existing devices)'
            })
          }else if( this.existingDateExistCount > 0 ){
            this.formInputs.push({
              id: 'existing',
              title: this.pageContent.existingDevice.heading,
              dateInput: this.createDatePickerInput('existing', 'newActive'),
              toolTipText: this.pageContent.existingDevice.toolTipText,
              label: 'Enrollment date (all existing devices)'
            })
            this.enrollmentCheckbox.disabled = true;
          }
        } else if (this.futureEnrollList.length > 0 && this.activeFANList.length > 0) { // no longer required same as 2nd
           this.formInputs = [{
            id: 'newActive',
            title: this.pageContent.newDevice.heading,
            dateInput: this.createDatePickerInput('new', 'newActive'),
            toolTipText: this.pageContent.newDevice.toolTipText,
            label: 'Enrollment date (enrolled devices)'
          },
          {
            id: 'existing',
            title: this.pageContent.existingDevice.heading,
            dateInput: this.createDatePickerInput('existing', 'newActive'),
            toolTipText: this.pageContent.existingDevice.toolTipText,
            label: 'Enrollment date (all existing devices)'
          }];
          this.enrollmentCheckbox.disabled = true;
        } else { //same as if
          this.formInputs = [{
            id: 'new',
            title: this.pageContent.newDevice.heading,
            dateInput: this.createDatePickerInput('new'),
            toolTipText: this.pageContent.newDevice.toolTipText,
            label: 'Enrollment date (devices pending enrollment)'
          }, {
            id: 'existing',
            title: this.pageContent.existingDevice.heading,
            dateInput: this.createDatePickerInput('existing'),
            toolTipText: this.pageContent.existingDevice.toolTipText,
            label: 'Enrollment date (all existing devices)'
          }
          ];
        }
    //   this.pageloaderService.setPageLoaderStatus(true);
    //  });
    this.signupService.createPageLoadProperties('STARTDATE', 'startdate');
    this.supportArticles = [{ id: 1, isActive: true, category: 'Help', description: '', ariaLabel:{
      'expand': 'Show help',
      'collapse': 'Hide help'
      }
      }];    const pageName = 'signupStartDatePage';
    this.signupService.requestSupportContent(this.utilityService.getEnvConfig().getSupportDocument + pageName).
      subscribe(resp => {
        this.supportArticle = true;
        this.article = resp.supportArticles;
        this.article.category = this.article.availableArticle;
        this.article.name = this.article.availableArticle[0].name;
      // }, (err) => {
      //   this.handleError(err);
      });
  }

  onDateChange(dateObj: any) {
    if (dateObj.id === 'new') {
      this.enrollDates.new = dateObj.date;
    } else {
      this.enrollDates.existing = this.enrollDates.new
      this.dateError = false;
      this.errorMessage = '';
    }
  }

  handleError(error, type?) {
    this.errorMessage = '';
 //   this.pageloaderService.setPageLoaderStatus(true);
  }

  getSupportContent(articleNumber) {
    if (this.article.availableArticle[articleNumber].type === 'popup') {
      this.initPopupModal(this.article.availableArticle[articleNumber].title, articleNumber);
    } else if (this.article.availableArticle[articleNumber].type === 'url') {
      console.log(this.article.availableArticle[articleNumber].url);

      this.router.navigateByUrl(this.article.availableArticle[articleNumber].url);
    }
  }

  initPopupModal(modalName, articleNumber) {
    this.confirmModalPopup = new ConfirmModalPopupModel();
    this.confirmModalPopup.modalSubHeader = '';
    // if (this.utilityService.getEnvConfig().useMock)
    // {
    //  this.manageInventoryService.requestPopupContent(this.utilityService.getEnvConfig().getSupportDocumentMock).
    //  subscribe(
    //  res => {
    //   this.confirmModalPopup.modalMessage = res.lock;
    //  });
    // }
    // else{
    this.signupService.requestPopupContent(this.utilityService.getEnvConfig().getSupportDocument + 'details/' + modalName).
      // this.signupService.requestPopupContent(this.utilityService.getEnvConfig().getSupportDocument+'details/'+modalName).
      subscribe(
        res => {
          this.title = res.articleDetails.name;
          this.confirmModalPopup.modalHeader = this.article.availableArticle[articleNumber].name;
          this.confirmModalPopup.modalMessage = res.articleDetails.content;
        });
    // }
    this.confirmModalPopup.confirmButtonMessage = 'OK';
    this.confirmModalPopup.showCancelButton = false;

    this.initModal = true;
    this.eventEmit = document.activeElement;
  }


  learn() {
    this.showSupportModal = true;
    this.eventEmit = document.activeElement;
    this.signupService.createPageLoadProperties('STARTDATEMODEL', 'Settings');

  }

  closeModal() {
    this.showSupportModal = false;
    this.initModal = false;
    this.signupService.createPageLoadProperties('STARTDATEMODEL', 'Settings');

  }

  showenroll() {
    this.showEnrollDetailsModal = true;
  }
  closePopupModal(confirm) {
    this.showEnrollDetailsModal = false;

  }

  back(event) {
    event.preventDefault();
    if (!this.oemStatus) {
      this.router.navigate(['signup/applications']);
    } else {
      this.router.navigate(['signup/settings']);
    }
  }

  next() {
    // tslint:disable-next-line:max-line-length
    this.adobeAnalyticsService.createAdobeEventProperties('MANAGE_DEVICE', 'SUCCESS', 'formSubmit', 'BC_Device_Signup_Select_Date_Submit', 'success', 'Success_Admit', 'Continue', 'Body', '/businessconsole/signup/review');
    // if (this.enrollDates.existing === undefined || this.enrollDates.existing == null || !this.enrollmentCheckbox.checked ) {
    //   this.enrollDates.existing = null;
    // }
    if( this.enrollmentCheckbox.checked ){
      let minDate = new Date();
      if(new Date( this.enrollDates.new ) > minDate ){
        this.enrollDates.existing = this.enrollDates.new;
      }else{ 
        this.enrollDates.existing = new Date( minDate.getFullYear(), minDate.getMonth(), (minDate.getDate() + 1));
      }
    }else{
      this.enrollDates.existing = null;
    }
    this.signupOutputModel.deviceEnrollDate = this.enrollDates;
    if (this.activeFANList.length || this.futureEnrollList.length) {
      this.signupOutputModel.FANList.revisedFanList = this.filterSelected(this.activeFANList.concat(this.futureEnrollList));
      if (!this.signupOutputModel.FANList.revisedFanList.length) {
        this.errorMessage = this.pageContent.errorMsg.noFANSelected;
        return;
      }
    }
    this.signupService.saveSignupModel(this.signupInputModel, this.signupOutputModel, this.initialSignup);
    // Adobe Analytics Starts
    // tslint:disable-next-line:max-line-length
    this.adobeAnalyticsService.createAdobeEventProperties('MANAGE_DEVICE', 'SUCCESS', 'formResponse', 'BC_Device_Signup_Select_Date_Submit', 'success', 'Success_Admit', 'Continue', 'Body', '/businessconsole/signup/review');
    // const data = { code: 'device_select_date_submit', errorType: 'SUCCESS_TYPE', successFlag: 1, msg: '' };
    // this.adobeAnalyticsService.trackEventProperties(data);
    // Ends
    this.router.navigate(['signup/review']);
    // this.dateError = true;
    // this.errorMessage = this.pageContent.errorMsg.selectDate;
  }

  createAccordionModel(id: string, ariaLabel) {
    const accordionModel = new AccordionModel();
    const fanList = (id === 'ActiveFAN') ? this.activeFANList : this.futureEnrollList;
    accordionModel.id = id;
    accordionModel.isActive = false;
    accordionModel.category = (id === 'ActiveFAN') ? (this.activeFANList.length + '&ensp; ' + this.pageContent.currentDeployAccount.gridHeaderPlural)
      : (this.futureEnrollList.length + '&ensp; ' + this.pageContent.futureDeployAccount.gridHeaderPlural);
    accordionModel.ariaLabel = ariaLabel;
    return accordionModel;
  }

  createDatePickerInput(id: string, label?) {
    let minDate = new Date();
    const maxDate = new Date(minDate.getFullYear(), minDate.getMonth(), (minDate.getDate() + 60));
    if(id == 'existing'){
      minDate = new Date(minDate.getFullYear(), minDate.getMonth(), (minDate.getDate() + 1));
      }
    let selectedDate = id === 'new' ? this.enrollDates.new : this.enrollDates.existing;
    // if (id === 'existing'){
    //   this.enrollDates.existing = selectedDate;
    //   }
    const dateInput = {
      id: id,
      minDate: minDate,
      maxDate: maxDate,
      datePickerLabel: this.pageContent[id + 'Device'].fieldLabel,
      selectedDate: undefined,
      disable: false,
      ariaLabel: this.pageContent[id + 'Device'].ariaLabel,
      labelColor: "enable-label"
    };
    if (selectedDate) {
      dateInput.selectedDate = new Date(selectedDate);
    }
    if (label === 'newActive') {
      dateInput.disable = true;
      dateInput.labelColor= "disable-label";
    }
    return dateInput;
  }

  createGridOptions(id: string) {
    const gridOption = new GridOptionsModel();
    const columns: ColumnDefinitionsModel = {
      field: 'fanId',
      caption: 'Foundation accounts',
      type: 'TEXT'
    };

    const pages: PaginationsModel = {
      recordsPerPage: 20,
      currentPage: 1,
      totalRecords: id === 'active' ? this.activeFANList.length : this.futureEnrollList.length,
      isServerSide: false,
    };

    gridOption.ariaLabel= "Select all foundation accounts.";
    gridOption.enableFiltering = false;
    gridOption.columnDefinitions = [columns];
    gridOption.enableSorting = false;
    gridOption.gridData = id === 'active' ? this.activeFANList : this.futureEnrollList;
    gridOption.Paginations = pages;
    gridOption.searchPlaceHolder = '';
    gridOption.searchDescriptions = '';
    gridOption.callbacks = null;
    gridOption.multiSelect = true;
    gridOption.disableGrid = false;
    gridOption.disableRow = false;
    gridOption.disableRowCondition = { field: '', value: '' };
    return gridOption;

  }

  filterSelected(fanList: Array<any>) {
    const filteredFans = new Array();
    fanList.forEach(fan => {
      if (fan.selected) {
        filteredFans.push(fan);
      }
    });
    return filteredFans;
  }


  updateFutureList = ($event: any) => {
    this.futureEnrollList = $event.griddata;
    // tslint:disable-next-line:max-line-length
    const title = (this.filterSelected(this.futureEnrollList).length === 1) ? this.filterSelected(this.futureEnrollList).length + ' Foundation Account Selected' : this.filterSelected(this.futureEnrollList).length + ' Foundation Accounts Selected';
    this.updateView(this.pageDescription[1], title);
  }

  updateActiveList = ($event: any) => {
    this.activeFANList = $event.griddata;
    // tslint:disable-next-line:max-line-length
    const title = (this.filterSelected(this.activeFANList).length === 1) ? this.filterSelected(this.activeFANList).length + ' Foundation Account Selected' : this.filterSelected(this.activeFANList).length + ' Foundation Accounts Selected';
    this.updateView(this.pageDescription[0], title);
  }

  updateView(description: any, title: string) {
    if (description.accordion) {
      description.accordion[0].category = title;
    } else {
      description.gridHeader = title;
    }
    if (!this.dateError) {
      this.errorMessage = '';
    }
  }

}
